import axios from 'axios';
import { checkStatusFunc, fetchHolderListFunc, parseJSONFunc } from '.';
import { BaseURL } from '../constants';

///Stock Home Page API'S
export const fetchFirstStock = async (symbol, date, setAppState) => {
  setAppState({ loading: true });
  try {
    const response = await axios.get(
      `${BaseURL}/api/get-firststocktable-data?symbol=${symbol}&date=${date}`
    );

    if (response && response.data.length) {
      setAppState({
        weekendErrors: null,
        stockFirstTable: response.data,
        loading: false,
      });
    } else {
      setAppState({
        stockFirstTable: [],
        loading: false,
        weekendErrors: " Can't Get Data Might be Weekend or Holiday",
      });
    }
  } catch (error) {
    setAppState({
      stockFirstTable: [],
      loading: false,
      weekendErrors: " Can't Get Data Might be Weekend or Holiday",
    });
  }
};

export const fetchSecondStock = async (symbol, date, setAppState) => {
  setAppState({ secondLoading: true });
  try {
    const response = await axios.get(
      `${BaseURL}/api/get-secondstocktable-data?symbol=${symbol}&date=${date}`
    );
    if (response && response.data.length) {
      setAppState({
        weekendErrorsBox2: null,
        stockSecondTable: response.data,
        secondLoading: false,
      });
    } else {
      setAppState({
        stockSecondTable: [],
        weekendErrorsBox2: " Can't Get Data Might be Weekend or Holiday",
        secondLoading: false,
      });
    }
  } catch (error) {
    setAppState({
      weekendErrorsBox2: " Can't Get Data Might be Weekend or Holiday",
      stockSecondTable: [],
      secondLoading: false,
    });
  }
};
export const fetchThirdStock = async (symbol, date, setAppState) => {
  setAppState({ ThirdLoading: true });
  try {
    const response = await axios.get(
      `${BaseURL}/api/get-thirdstocktable-data?symbol=${symbol}&date=${date}`
    );
    if (response && response.data.length) {
      setAppState({
        stockThirdTable: response.data,
        weekendErrorsBox3: null,
        ThirdLoading: false,
      });
    } else {
      setAppState({
        stockThirdTable: [],
        weekendErrorsBox3: " Can't Get Data Might be Weekend or Holiday",
        ThirdLoading: false,
      });
    }
  } catch (error) {
    setAppState({
      weekendErrorsBox3: " Can't Get Data Might be Weekend or Holiday",
      stockThirdTable: [],
      ThirdLoading: false,
    });
  }
};

export const fetchtopVolume = async (symbol, date, setAppState) => {
  fetch(`${BaseURL}/api/get-topvolume-data?symbol=${symbol}&date=${date}`)
    .then((res) => checkStatusFunc(res, setAppState))
    .then((res) => parseJSONFunc(res))
    .then((response) => {
      if (response && response.length) {
        setAppState({ topVolumeData: response });
      } else {
        setAppState({ topVolumeData: [] });
      }
    });
};
export const fetchSecondtopTable = async (symbol, date, setAppState) => {
  fetch(`${BaseURL}/api/get-secondvolume-data?symbol=${symbol}&date=${date}`)
    .then((res) => checkStatusFunc(res, setAppState))
    .then((res) => parseJSONFunc(res))
    .then((response) => {
      if (response && response.length) {
        response.length >= 2
          ? setAppState({
              secondTopTableData: response[1],
            })
          : setAppState({
              secondTopTableData: response[0],
            });
      } else {
        setAppState({ secondTopTableData: [] });
      }
    });
};

export const fetchAllMain = async (symbol, date, setAppState) => {
  fetchHolderListFunc(symbol, setAppState);
  fetchFirstStock(symbol, date, setAppState);
  fetchSecondStock(symbol, date, setAppState);
  fetchThirdStock(symbol, date, setAppState);
  fetchtopVolume(symbol, date, setAppState);
  fetchSecondtopTable(symbol, date, setAppState);
};



// WEBPACK FOOTER //
// ./src/Shared/stocks.js